<template>
  <formulario ref="formulario" class="row">
    <!--Logo-->
    <!--Cargador de imagen para comercio de vista admin-->
    <div class="mb-3" v-if="esAdmin">
      <CargadorImagen ref="cargadorImagen" />
      <p v-show="editando" class="info-bajo-input">
        Si no se elige un logo, se mantendrá el actual.
      </p>
    </div>

    <!--Imagen fija del logo para vista comerciante-->
    <div class="img-comercio" v-if="!esAdmin">
      <div v-if="item.logoUrl">
        <img v-bind:src="UrlBase + 'images/logos/' + item.logoUrl" />
      </div>
      <div v-else>
        <p class="info-bajo-input">
          Sin logo.
        </p>
      </div>
    </div>

    <div class="col-md-6">
      <!--Nombre-->
      <div class="form-floating mb-3">
        <input v-model="item.name" maxlength="30" required type="text" class="form-control" id="floatingNombre"
          placeholder="Nombre de ejemplo" />
        <label for="floatingNombre">Nombre del comercio</label>
      </div>
    </div>
    <div class="col-md-6">
      <!--Dirección-->
      <div class="form-floating mb-3">
        <input v-model="item.address" maxlength="40" type="text" class="form-control" id="floatingDireccion"
          placeholder="Dirección de ejemplo 123" />
        <label for="floatingDireccion">Dirección</label>
      </div>
    </div>
    <!--Teléfono-->
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <input v-model="item.phone" maxlength="40" type="tel" class="form-control" id="floatingTelefono"
          placeholder="1234-56789" />
        <label for="floatingTelefono">Teléfono</label>
      </div>
    </div>
    <!--WhatsApp-->
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <input v-model="item.whatsapp" maxlength="40" type="tel" class="form-control" id="floatingWhatsapp"
          placeholder="3446-406789" />
        <label for="floatingWhatsapp">WhatsApp</label>
      </div>
    </div>
    <!--CUIT-->
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <input v-model="item.cuit" maxlength="30" type="text" class="form-control" id="floatingCuit"
          placeholder="20-123456789-5" />
        <label for="floatingCuit">CUIT</label>
      </div>
    </div>
    <!--Correo electrónico-->
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <input v-model="item.email" maxlength="100" type="email" class="form-control" id="floatingEmail"
          placeholder="ejemplo@correo.com" />
        <label for="floatingEmail">Correo electrónico</label>
      </div>
    </div>

    <!--Minimum discount percentage-->
    <div v-if="!hideMinimumDiscount" class="col-md-6">
      <div class="form-floating mb-3">
        <input v-model="item.minimumDiscountPercentage" type="number" class="form-control" placeholder=""
          id="floatingMinimumDiscountPercentage" maxlength="2" />
        <label for="floatingMinimumDiscountPercentage">Descuento mínimo</label>
      </div>
    </div>

    <!-- Habilitar/deshabilitar -->
    <div>
      <input class="form-check-input" v-model="item.activo" type="checkbox" id="checkActivo" />
      <label class="form-check-label" for="checkActivo">Activo</label>
    </div>

    <div v-if="item.activo && esAdmin">
      <input
        class="form-check-input"
        v-model="item.excluyeCompanias"
        type="checkbox"
        id="checkExcluirCompanias"
        @change="refrescarSelect($event)"
      />
      <label class="form-check-label" for="checkExcluirCompanias"
        >Excluir Compañías</label
      >
    </div>

    <div v-if="item.excluyeCompanias && item.activo && esAdmin">
      <multiselect
        v-model="item.companiasSeleccionadas"
        :options="options"
        :multiple="true"
        placeholder="Seleccionar las companias"
        label="nombre"
        track-by="nombre"
      >
      </multiselect>
    </div>
    <!-- Input Url QR -->
    <div class="my-3 d-flex align-items-center container-input-qr">
      <div class="form-floating flex-grow-1">
        <input v-model="item.urlQR" maxlength="100" type="url" class="form-control" id="floatingQR"
          placeholder="https://www.ejemplo.com/"
          pattern="^(http(s?):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$"
          :disabled="!esAdmin" />
        <label for="floatingQR">Link QR Beneficio <small>(opcional)</small></label>
        <div class="invalid-feedback">
          Formato válido: http(s)://www.ejemplo.com
        </div>
      </div>

      <div class="botonera-qr">
        <!-- Boton copy -->
        <button class="btn btn-primary mx-1" type="button" v-clipboard:copy="item.urlQR"
          v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError" :disabled="!item.urlQR">
          <font-awesome-icon :icon="Icons.COPIAR" />
        </button>
        <!-- Boton qr -->
        <button class="btn btn-dark mx-1" type="button" :disabled="!item.urlQR" v-popover:popoverContent.left>
          <font-awesome-icon :icon="Icons.QR" />
        </button>
        <popover name="popoverContent" class="popover-qr">
          <vue-qrcode :value="item.urlQR" id="qrRoot" />
          <!-- Boton descargar -->
          <button class="btn btn-success mb-2" type="button" :disabled="!item.urlQR" @click="descargarQR">
            <span>Descargar</span>
            <font-awesome-icon :icon="Icons.DESCARGAR" />
          </button>
        </popover>
      </div>
    </div>

    <div class="mb-3">
      <input class="form-check-input" v-model="esGlobal" @change="comercioGlobal($event)" type="checkbox" id="ubicacionGlobal" />
      <label class="form-check-label" for="ubicacionGlobal">Ubicación global</label>
    </div>
    <!-- Provincia y localidad -->
    <SelectorLocalidad ref="selectorLocalidad" claseSelects="col-md-6" v-on:provincia-cambiada="provinciaCambiada($event)"
      v-on:localidad-cambiada="localidadCambiada($event)" v-if="!esGlobal" required class="row mb-4 fila-selector" />
    <!-- Redes sociales -->
    <label>Redes sociales</label>

    <!-- Url de sitio web -->
    <div class="col-md-4 redes-sociales__form-comercio">
      <div class="form-floating mb-3">
        <input v-model="item.urlWebsite" maxlength="100" type="url" class="form-control" id="floatingWebsite"
          placeholder="https://www.sitioweb.com/"
          pattern="^(http(s?):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$"
          :readonly="disableSocialNetworks" />
        <label for="floatingWebsite">Link de Sitio web <small>(opcional)</small></label>
        <small class="invalid-feedback">
          Formato válido: http(s)://www.ejemplo.com
        </small>
      </div>
    </div>
    <!-- Url de Facebook -->
    <div class="col-md-4 redes-sociales__form-comercio">
      <div class="form-floating mb-3">
        <input v-model="item.urlFacebook" maxlength="100" type="url" class="form-control" id="floatingFacebook"
          placeholder="https://www.facebook.com/usuario"
          pattern="^(http(s?):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$"
          :readonly="disableSocialNetworks" />
        <label for="floatingFacebook">Link de Facebook <small>(opcional)</small></label>
        <small class="invalid-feedback">
          Formato válido: http(s)://www.ejemplo.com
        </small>
      </div>
    </div>
    <!-- Url de Instagram -->
    <div class="col-md-4 redes-sociales__form-comercio">
      <div class="form-floating mb-3">
        <input v-model="item.urlInstagram" maxlength="100" type="url" class="form-control" id="floatingInstagram"
          placeholder="https://www.instagram.com/usuario"
          pattern="^(http(s?):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$"
          :readonly="disableSocialNetworks" />
        <label for="floatingInstagram">Link de Instagram <small>(opcional)</small></label>
        <small class="invalid-feedback">
          Formato válido: http(s)://www.ejemplo.com
        </small>
      </div>
    </div>
    <!-- Leyenda -->
    <label v-if="disableSocialNetworks" class="fst-italic">
      Si desea corregir algún dato, comunicarse con el staff de Sumá Beneficios.
    </label>
  </formulario>
</template>

<script>
import { environment } from "../../../environments/environment";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import CargadorImagen from "../../util/CargadorImagen";
import { Carpetas, Icons } from "../../../constants";
import Formulario from "./Formulario.vue";
import SelectorLocalidad from "../../util/SelectorLocalidad.vue";
import { Util } from "../../../util";
import Swal from "sweetalert2";
import VueQrcode from "vue-qrcode";
import Multiselect from "vue-multiselect";
import axios from "axios";

// Usado para realizar copias profundas y para que las computed properties funcionen correctamente
// a la hora de limpiar los datos del beneficio solo hay que hacer copiaProfunda de este objeto
const ITEM_LIMPIO = {
  id: null,
  activo: true,
  cuit: null,
  direccion: null,
  email: null,
  minimumDiscountPercentage: 10,
  nombre: null,
  /** Objeto localidad */
  localidad: null,
  /** Nombre del archivo de logo */
  logo: null,
  telefono: null,
  whatsapp: null,
  urlWebsite: null,
  urlFacebook: null,
  urlInstagram: null,
  urlQR: null,
  excluyeCompanias: false,
  companiasExcluidas: null,
};

export default {
  props: {
    /** Para saber si se está editando o creando */
    editando: Boolean,
    hideMinimumDiscount: Boolean,
    disableSocialNetworks: Boolean,
    esAdmin: Boolean,
  },
  components: {
    FontAwesomeIcon,
    CargadorImagen,
    Formulario,
    SelectorLocalidad,
    VueQrcode,
    Multiselect,
  },
  data() {
    return {
      item: Util.copiaProfunda(ITEM_LIMPIO),
      esGlobal: false,
      selected: null,
      options: [],
    };
  },
  computed: {
    /**Dirección de la carpeta de logos */
    CarpetaLogos() {
      return environment.API_URL + Carpetas.LOGOS;
    },
    Editando() {
      return this.editando;
    },
    Item() {
      return this.item;
    },
    UrlBase() {
      return environment.API_URL;
    },
    Icons() {
      return Icons;
    },
  },
  methods: {
    getCompaniasSb() {
      axios.get(environment.API_URL + "sb/companiasFromSb").then((response) => {
        this.options = response.data;
      });
    },
    // Descarga el QR del comercio actual
    descargarQR() {
      // Obtener el link de la imagen temporal generada por el componente de QR
      const imageLink = document.getElementById("qrRoot").src;

      // Crear un elemento temporal <a> para poder descargar
      let a = document.createElement("a");
      a.href = imageLink;

      // Nombre del archivo descargado
      if (!this.item.id) {
        a.download = "QR_Beneficio" + ".png";
      } else {
        a.download =
          this.item.id +
          "_" +
          this.item.name.replace(/\s/g, "") +
          "_" +
          "QR_Beneficio" +
          ".png";
      }
      document.body.appendChild(a);

      // Simular un click para descargar
      a.click();

      // Eliminar elemento temporal
      document.body.removeChild(a);
    },

    // Alerta para mostrar que se copio al portapapeles
    onCopySuccess() {
      return Swal.fire({
        icon: "success",
        title: "Copiado al portapeles",
        timer: 2000,
        showConfirmButton: false,
      });
    },

    // Alerta para mostrar que no se copio al portapapeles, error
    onCopyError() {
      return Swal.fire({
        icon: "error",
        title: "Ocurrió un error al copiar",
        timer: 2000,
        showConfirmButton: false,
      });
    },
    comercioGlobal(event) {
      var data = event.target.checked;
      this.esGlobal = data;
      this.item.localidad = 0;
      this.item.provincia = 0;
    },
    esValido() {
      return this.$refs.formulario.esValido();
    },
    /** Convierte el item a dto y lo devuelve */
    dto() {
      if (this.item)
        return {
          id: this.item.id,
          activo: this.item.activo,
          name: this.item.name,
          address: this.item.address,
          phone: this.item.phone,
          cuit: this.item.cuit,
          whatsapp: this.item.whatsapp,
          email: this.item.email,
          provinciaId: this.item.provincia ? this.item.provincia.id : undefined,
          localidadId: this.item.localidad ? this.item.localidad.id : undefined,
          urlWebsite: this.item.urlWebsite,
          urlFacebook: this.item.urlFacebook,
          urlInstagram: this.item.urlInstagram,
          urlQR: this.item.urlQR,
        };
      else return null;
    },
    getArchivoLogo() {
      return this.$refs.cargadorImagen.getArchivo();
    },
    getEstadoLogo() {
      return this.$refs.cargadorImagen.estado;
    },
    localidadCambiada(localidad) {
      this.item.localidad = localidad;
    },
    provinciaCambiada(provincia) {
      this.item.provincia = provincia;
    },
    copiar(item) {
      if (item.excluyeCompanias && item.companiasExcluidas) {
        let arrayOpcionesSeleccionadas = [];
        item.companiasExcluidas.forEach(
          (elemento) => {
            this.options.forEach((option) => {
              if (option.id == elemento) {                
                arrayOpcionesSeleccionadas.push(option);
                
              }
            });
          } 
        );
        item.companiasSeleccionadas = arrayOpcionesSeleccionadas;        
      }

      // Trabajar con una copia profunda para que no se apliquen los cambios directamente
      this.item = Util.copiaProfunda(item);

      // En modo edición se oculta
      if (this.$refs.selectorLocalidad) {
        // Es importante seleccionar en este orden
        this.$refs.selectorLocalidad.seleccionarProvinciaPorId(
          item.provinciaId ?? null
        );
        this.$refs.selectorLocalidad.seleccionarLocalidadPorId(
          item.localidadId ?? null
        );
      }

      if (item.logoUrl && this.esAdmin) {
        const urlAbsoluta = this.CarpetaLogos + item.logoUrl;
        this.$refs.cargadorImagen.EventoCargarURL(urlAbsoluta);
      }

      this.esGlobal = item.localidadId == 0 ? true : false;
    },
    limpiar() {
      // Es necesario que no sea simplemente una borrada de campos
      // Ya que en tal caso dejarían de funcionar correctamente
      // los métodos en "computed"
      this.item = Util.copiaProfunda(ITEM_LIMPIO);

      if (this.$refs.selectorLocalidad) {
        this.$refs.selectorLocalidad.limpiar();
      }

      this.esGlobal = false;

      // Borra el logo del input
      this.$refs.cargadorImagen.EventoLimpiar();
    },
    limpiarFeedback() {
      this.$refs.formulario.limpiarFeedback();
    },
    mostrarFeedback() {
      this.$refs.formulario.mostrarFeedback();
    },
    refrescarSelect(event){       
      var checkeado = event.target.checked;      
      
      if(checkeado && this.item.companiasExcluidas){
        let arrayOpcionesSeleccionadas = [];
        
        this.item.companiasExcluidas.forEach(companiaSeteada=>{
         
          this.options.forEach(option =>{
            if (option.id == companiaSeteada) {
              arrayOpcionesSeleccionadas.push(option);
            }
          })
        });

        let itemAuxiliar = Util.copiaProfunda(this.item);        
        itemAuxiliar.companiasSeleccionadas = arrayOpcionesSeleccionadas;
        
        this.item = Util.copiaProfunda(itemAuxiliar);
      }
    }
  },
  mounted() {
    this.getCompaniasSb();
  },
};
</script>
<style lang="scss">
.img-comercio img {
  margin-bottom: 2rem;
  width: 30%;

  @media screen and (max-width: 991px) {
    width: 50%;
  }

  @media screen and (max-width: 575px) {
    width: 75%;
    margin-bottom: 1rem;
  }

  @media screen and (max-width: 450px) {
    width: 100%;
    margin-bottom: 1rem;
  }
}

.redes-sociales__form-comercio {
  @media screen and (max-width: 993px) {
    label,
    small {
      font-size: 14px;
    }
  }
}

.container-input-qr {
  column-gap: 1rem;

  .botonera-qr {
    height: 100%;

    button {
      height: 100%;
      width: 58px;

      @media screen and (max-width: 450px) {
        width: auto;
      }
    }

    .popover-qr {
      transform: translateY(-64px);

      button {
        min-width: 126px;

        span {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>